import axiosInstance from "./index.services";

export async function CricketPredictionUpdatePoints(data: {
  toss_winner_point: number;
  match_winner_point: number;
  player_of_the_match_point: number;
}) {
  return await axiosInstance.post(`/cricket-point/`, data);
}

export async function CricketMatchPredictionFetch(params?: any) {
  return await axiosInstance.get(`/cricket-match-prediction/`, { params });
}

export function GetCricketMatchPoints() {
  return axiosInstance.get(`/cricket-point/`);
}

